import { Container } from 'react-bootstrap';

const PartnerAffiliateFooter = () => (
  <footer className="bg-dark text-white py-3 mt-5 border-top border-secondary">
    <Container className="text-center">
      <small className="d-block">&copy; {new Date().getFullYear()} South Crete Tours SA - All Rights Reserved.</small>
      <small className="d-block text-white-50 mt-1">
        Real-time availability &amp; reliable booking operations
      </small>
    </Container>
  </footer>
);

export default PartnerAffiliateFooter;
